import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Card, Row, Col, Nav } from 'react-bootstrap'

class DashBox extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
  
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }

      render(){
  
          return (
            <Nav.Link>
            <Card className='fuseHover p-0'
            bg={this.props.colour}>
            <Card.Body>
              <Row className='p-0'>
                <Col xs={2}><i className={`fa ${this.props.icon} fa-3x float-left`}></i></Col>
                <Col xs={10} className="d-flex align-items-end flex-column">
                  <Row className="p-2"><Card.Title as = "h1"><strong>{this.props.count}</strong></Card.Title></Row>
                </Col> 
                <Col xs={12} className="d-flex align-items-end flex-column">
                  <Row><Card.Subtitle as = "h5" className="text-right">{this.props.countDetail}</Card.Subtitle></Row>
                </Col>                 
                {/* <Card.Text>
                  Blah blah blah
                </Card.Text> */}
              </Row>
            </Card.Body>
            <Card.Footer>
            {/* <Row fluid className="no-gutters">
              <Col xs={11}>View Details</Col>
                  <Col xs={1}>
                    <Row><i className="fa fa-arrow-circle-right"></i></Row>
                  </Col>  
              </Row> */}
              View Details <i className="fa fa-arrow-circle-right float-right"></i>
            </Card.Footer>
          </Card>
          </Nav.Link>
            );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
  
        })
      )(DashBox);